import {get, post} from '@/utils/apiBase.js'
// 推广记录
export const getMarketRecordList = (option) => {
    return get('/market/extension/market_record_list', option);
};
// 购买记录
export const getPurchaseRecordList = (option) => {
    return get('/market/extension/purchase_record_list', option);
};
// 订单支付
export const marketOrderPay = (option) => {
    return post('/market/extension/order_pay', option);
};
// 取消订单
export const marketCancelOrder = (option) => {
    return post('/market/extension/cancel_order', option);
};
// 短信推广---获取信息
export const marketMessageIndex = (option) => {
    return post('/market/extension/message_index', option);
};
// 提交推广
export const AddMarketRecord = (option) => {
    return post('/market/extension/add_market_record', option);
};
// 校验订单支付状态
export const GetWalletOrderStatus = (option) => {
    return get('/wallet/order/status', option);
};


export default {
    getMarketRecordList,
    getPurchaseRecordList,
    marketOrderPay,
    marketCancelOrder,
    marketMessageIndex,
    AddMarketRecord,
    GetWalletOrderStatus
};